module.exports = __webpack_public_path__ + "static/media/sleep.80d02b24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Calculator/icons/sleep.jpg
// module id = 560
// module chunks = 0